<template>
  <span>
    <div style="margin-bottom:10px">
      <el-collapse-transition>
        <el-alert v-if="errorMsg" :title="errorMsg" type="error" :closable="false" />
      </el-collapse-transition>
    </div>
    <embedded-crud-table
      :allow-create="allowCreate()"
      :entity="entity"
      :entity-store="entityStore"
      :columns="columns"
      :definition="definition"
      :generate-summary="() => {}"
      :caption="caption"
      parent-id-filter-field="orderLineID"
      :open-in-fullscreen="openInFullscreen"
      :required="required"
      :create-item-from-form-data="createItemFromFormData"
      :create-form-data-from-item="createFormDataFromItem"
      :show-summary-row="true"
      :get-summaries="getSummaries"
      :disable-filtering="true"
      :use-pagination="false"
      :show-action-icons-in-list="!invoicedYN && (interiorDecoratorOrderYN || returnOrderLineYN)"
      :on-table-row-double-click="invoicedYN ? showErrorMsg : null"
    />
  </span>
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';
import { hasExecutePermissionForCode } from '@/utils/permission';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    invoicedYN: {
      default: false,
      type: Boolean
    },
    returnOrderLineYN: {
      default: false,
      type: Boolean
    },
    interiorDecoratorOrderYN: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    entity: 'OrderLinePrice',
    errorMsg: ''
  }),
  computed: {
    columns() {
      return [
        { field: 'externalInvoiceNumber', label: 'invoice.externalInvoice', filter: { type: 'none' }, width: 175 },
        { field: 'internalInvoiceNumber', label: 'invoice.internalInvoice', filter: { type: 'none' }, width: 175 },
        { field: 'description', filter: { type: 'none' } },
        {
          field: 'orderLinePriceType',
          label: 'orderLine.orderLinePriceType',
          formatter: this.formatOrderLinePrice,
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'quantity',
          label: 'orderLine.quantity',
          filter: { type: 'none' },
          width: 150,
          align: 'right'
        },
        {
          field: 'unit',
          formatter: this.formatUnit,
          filter: { type: 'none' },
          sortable: false,
          width: 150,
          align: 'center'
        },
        {
          field: 'price',
          filter: { type: 'none' },
          formatter: this.formatPrice,
          width: 150,
          align: 'right'
        },
        {
          field: 'discountPercentage',
          label: 'orderLine.discountPercentage',
          formatter: this.formatDiscountPercentage,
          filter: { type: 'none' },
          width: 175,
          align: 'right'
        },
        {
          field: 'amount',
          label: 'orderLine.totalAmount',
          filter: { type: 'none' },
          formatter: this.formatPrice,
          sortable: false,
          width: 150,
          align: 'right'
        },
        {
          field: 'currencyISOCode',
          label: 'common.currency',
          filter: { type: 'none' },
          sortable: false,
          width: 150,
          align: 'center'
        }
      ];
    }
  },
  methods: {
    allowCreate() {
      return !this.invoicedYN && hasExecutePermissionForCode(this.entity, this.$store.getters.permissions);
    },
    showErrorMsg() {
      this.errorMsg = this.$i18n.t('orderLine.priceRestricted');
    },
    formatUnit(row, column, cellValue) {
      const option =
        cellValue !== null
          ? this.$store.getters['option/loadedOptions']('capacityUnit').find(item => item.code === cellValue)
          : '';
      return option && option.description;
    },
    formatPrice(row, column, cellValue) {
      if (isNaN(cellValue)) {
        return '';
      }
      return `${cellValue.toFixed(2)}`;
    },
    formatDiscountPercentage(row, column, cellValue) {
      if (isNaN(row.discountPercentage) || !row.discountPercentage) {
        return '';
      }
      return `${cellValue.toFixed(2)}`;
    },
    formatOrderLinePrice(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('orderLinePriceType').find(item => item.code === cellValue);
      return option && option.description;
    },
    getSummaries(param) {
      const sums = [];
      sums[0] = this.$i18n.t('common.total');
      const total = param.data.map(i => i.amount).reduce((a, b) => a + b, 0);
      sums[8] = total.toFixed(2);
      const lineWithCurrency = param.data.find(i => i.currencyISOCode);
      sums[9] = lineWithCurrency && lineWithCurrency.currencyISOCode;
      return sums;
    }
  }
};
</script>

<style scoped></style>
